export const ACCUSATIVE_COUNTRY_NAMES: Partial<Record<number, string>> = {
  92: 'Турцию',
  29: 'Египет',
  68: 'ОАЭ',
  87: 'Таиланд',
  76: 'Россию',
  22: 'Вьетнам',
  44: 'Китай',
  1: 'Абхазию',
  56: 'Мальдивы',
  91: 'Тунис',
  94: 'Узбекистан',
  3: 'Австрию',
  119: 'Азербайджан',
  120: 'Албанию',
  4: 'Андорру',
  6: 'Армению',
  10: 'Бахрейн',
  11: 'Беларусь',
  12: 'Бельгию',
  13: 'Болгарию',
  21: 'Венесуэлу',
  20: 'Венгрию',
  157: 'Гамбию',
  24: 'Германию',
  26: 'Грецию',
  129: 'Грузию',
  27: 'Данию',
  28: 'Доминикану',
  32: 'Израиль',
  33: 'Индию',
  34: 'Индонезию',
  35: 'Иорданию',
  36: 'Ирландию',
  38: 'Испанию',
  39: 'Италию',
  156: 'Казахстан',
  41: 'Камбоджу',
  135: 'Катар',
  42: 'Кению',
  43: 'Кипр',
  47: 'Коста-Рику',
  48: 'Кубу',
  49: 'Кыргызстан',
  50: 'Латвию',
  52: 'Литву',
  53: 'Маврикий',
  55: 'Малайзию',
  57: 'Мальту',
  59: 'Марокко',
  60: 'Мексику',
  65: 'Нидерланды',
  67: 'Норвегию',
  69: 'Оман',
  75: 'Португалию',
  77: 'Румынию',
  78: 'Сейшелы',
  260: 'Саудовскую Аравию',
  81: 'Сербию',
  82: 'Сингапур',
  83: 'Словакию',
  84: 'Словению',
  88: 'Танзанию',
  97: 'Филиппины',
  98: 'Финляндию',
  99: 'Францию',
  101: 'Хорватию',
  104: 'Черногорию',
  105: 'Чехию',
  108: 'Швецию',
  107: 'Швейцарию',
  110: 'Шри-Ланку',
  113: 'Эстонию',
  116: 'Южную Корею',
  117: 'Ямайку',
  118: 'Японию',
};
